import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import LogInModal from 'flarum/forum/components/LogInModal';
import PasatiemposLeaderboard from './PasatiemposLeaderboard';
export default class LehoidleGame extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "hasStarted", false);
    _defineProperty(this, "submitting", false);
    _defineProperty(this, "roundId", '');
    _defineProperty(this, "targetId", 0);
    _defineProperty(this, "targetPlayer", null);
    _defineProperty(this, "candidates", []);
    _defineProperty(this, "maxAttempts", 8);
    // State
    _defineProperty(this, "guesses", []);
    _defineProperty(this, "selectedCandidate", null);
    _defineProperty(this, "searchQuery", '');
    _defineProperty(this, "dropdownOpen", false);
    _defineProperty(this, "radar", null);
    // Timer
    _defineProperty(this, "timerSeconds", 0);
    _defineProperty(this, "timerInterval", null);
    // Results
    _defineProperty(this, "isFinished", false);
    _defineProperty(this, "isSolved", false);
    _defineProperty(this, "results", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.fetchNewRound();
  }
  onremove(vnode) {
    this.stopTimer();
    super.onremove(vnode);
  }
  startTimer() {
    this.stopTimer();
    this.timerSeconds = 0;
    this.timerInterval = setInterval(() => {
      this.timerSeconds++;
      m.redraw();
    }, 1000);
  }
  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }
  fetchNewRound() {
    this.loading = true;
    this.hasStarted = false;
    this.submitting = false;
    this.isFinished = false;
    this.isSolved = false;
    this.results = null;
    this.guesses = [];
    this.selectedCandidate = null;
    this.searchQuery = '';
    this.dropdownOpen = false;
    this.radar = null;
    this.stopTimer();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/games/lehoidle/round'
    }).then(response => {
      this.roundId = response.round_id || '';
      this.targetId = response.target_id || 0;
      this.targetPlayer = response.target_player || null;
      this.candidates = response.candidates || [];
      this.maxAttempts = response.max_attempts || 8;
      this.updateRadar();
      this.loading = false;
      m.redraw();
    }).catch(err => {
      this.loading = false;
      app.alerts.show({
        type: 'error'
      }, 'Error al cargar Lehoidle. Inténtalo de nuevo.');
      m.redraw();
    });
  }
  startGame() {
    this.hasStarted = true;
    this.startTimer();
    m.redraw();
  }
  selectCandidate(candidate) {
    this.selectedCandidate = candidate;
    this.searchQuery = candidate.name;
    this.dropdownOpen = false;
    m.redraw();
  }
  submitGuess() {
    if (!this.selectedCandidate || !this.targetPlayer || this.isFinished) return;
    const p = this.selectedCandidate;
    const t = this.targetPlayer;
    const isMatch = p.id === t.id;
    const comparison = {
      player: p,
      position_match: p.position === t.position,
      number_direction: p.number === t.number ? 'exact' : p.number < t.number ? 'higher' : 'lower',
      height_direction: p.height === t.height ? 'exact' : p.height < t.height ? 'higher' : 'lower',
      weight_direction: p.weight === t.weight ? 'exact' : p.weight < t.weight ? 'higher' : 'lower',
      age_direction: p.age === t.age ? 'exact' : p.age < t.age ? 'higher' : 'lower',
      territory_match: p.territory === t.territory,
      is_target: isMatch
    };
    this.guesses.push(comparison);
    this.selectedCandidate = null;
    this.searchQuery = '';
    this.dropdownOpen = false;
    this.updateRadar();
    if (isMatch) {
      this.isSolved = true;
      this.finishGame();
    } else if (this.guesses.length >= this.maxAttempts) {
      this.isSolved = false;
      this.finishGame();
    }
    m.redraw();
  }
  updateRadar() {
    if (!this.targetPlayer || this.candidates.length === 0) return;
    const t = this.targetPlayer;
    const numbers = this.candidates.map(c => c.number);
    const heights = this.candidates.map(c => c.height);
    const ages = this.candidates.map(c => c.age);
    const weights = this.candidates.map(c => c.weight);
    let minDorsal = Math.min(...numbers);
    let maxDorsal = Math.max(...numbers);
    let minHeight = Math.min(...heights);
    let maxHeight = Math.max(...heights);
    let minAge = Math.min(...ages);
    let maxAge = Math.max(...ages);
    let minWeight = Math.min(...weights);
    let maxWeight = Math.max(...weights);
    let confirmedPosition = null;
    const discardedPositions = new Set();
    let confirmedTerritory = null;
    const discardedTerritories = new Set();
    for (const g of this.guesses) {
      const p = g.player;

      // Position
      if (p.position === t.position) {
        confirmedPosition = t.position;
      } else {
        discardedPositions.add(p.position);
      }

      // Territory
      if (p.territory === t.territory) {
        confirmedTerritory = t.territory;
      } else {
        discardedTerritories.add(p.territory);
      }

      // Number
      if (p.number === t.number) {
        minDorsal = t.number;
        maxDorsal = t.number;
      } else if (p.number < t.number) {
        minDorsal = Math.max(minDorsal, p.number + 1);
      } else {
        maxDorsal = Math.min(maxDorsal, p.number - 1);
      }

      // Height
      if (p.height === t.height) {
        minHeight = t.height;
        maxHeight = t.height;
      } else if (p.height < t.height) {
        minHeight = Math.max(minHeight, p.height + 1);
      } else {
        maxHeight = Math.min(maxHeight, p.height - 1);
      }

      // Age
      if (p.age === t.age) {
        minAge = t.age;
        maxAge = t.age;
      } else if (p.age < t.age) {
        minAge = Math.max(minAge, p.age + 1);
      } else {
        maxAge = Math.min(maxAge, p.age - 1);
      }

      // Weight
      if (p.weight === t.weight) {
        minWeight = t.weight;
        maxWeight = t.weight;
      } else if (p.weight < t.weight) {
        minWeight = Math.max(minWeight, p.weight + 1);
      } else {
        maxWeight = Math.min(maxWeight, p.weight - 1);
      }
    }
    const matching = this.candidates.filter(c => {
      if (confirmedPosition && c.position !== confirmedPosition) return false;
      if (discardedPositions.has(c.position)) return false;
      if (confirmedTerritory && c.territory !== confirmedTerritory) return false;
      if (discardedTerritories.has(c.territory)) return false;
      if (c.number < minDorsal || c.number > maxDorsal) return false;
      if (c.height < minHeight || c.height > maxHeight) return false;
      if (c.age < minAge || c.age > maxAge) return false;
      if (c.weight < minWeight || c.weight > maxWeight) return false;
      return true;
    });
    this.radar = {
      minDorsal,
      maxDorsal,
      minHeight,
      maxHeight,
      minAge,
      maxAge,
      minWeight,
      maxWeight,
      confirmedPosition,
      discardedPositions: Array.from(discardedPositions),
      confirmedTerritory,
      discardedTerritories: Array.from(discardedTerritories),
      matchingCandidates: matching
    };
  }
  finishGame() {
    this.submitting = true;
    this.stopTimer();
    const payloadGuesses = this.guesses.map(g => ({
      id: g.player.id,
      name: g.player.name
    }));
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/games/lehoidle/submit',
      body: {
        round_id: this.roundId,
        guesses: payloadGuesses,
        duration_seconds: this.timerSeconds
      }
    }).then(response => {
      this.submitting = false;
      this.isFinished = true;
      this.results = response;
      m.redraw();
    }).catch(err => {
      this.submitting = false;
      this.isFinished = true;
      this.results = {
        score: this.isSolved ? LehoidleGame.POINTS_BY_ATTEMPT[this.guesses.length] || 100 : 0,
        is_solved: this.isSolved,
        solved_at_attempt: this.isSolved ? this.guesses.length : 0,
        total_attempts: this.guesses.length,
        duration_seconds: this.timerSeconds,
        target_player: this.targetPlayer
      };
      m.redraw();
    });
  }
  getFilteredCandidates(query) {
    const triedIds = new Set(this.guesses.map(g => g.player.id));
    const available = this.candidates.filter(c => !triedIds.has(c.id));
    if (!query.trim()) {
      return available.slice(0, 8);
    }
    const cleanQuery = this.normalizeStr(query);
    return available.filter(c => this.normalizeStr(c.name).includes(cleanQuery) || String(c.number) === query.trim()).slice(0, 10);
  }
  normalizeStr(str) {
    return str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  formatTimer(seconds) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return "".concat(m, ":").concat(s < 10 ? '0' : '').concat(s);
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "lehoidle-game loading-state"
      }, m(LoadingIndicator, null), m("p", null, "Preparando el le\xF3n misterioso..."));
    }
    if (this.isFinished && this.results) {
      return this.renderResults();
    }
    if (!this.hasStarted) {
      return this.renderWelcome();
    }
    return this.renderPlayScreen();
  }
  renderWelcome() {
    return m("div", {
      className: "lehoidle-game welcome-card"
    }, m("div", {
      className: "welcome-hero"
    }, m("span", {
      className: "welcome-emoji"
    }, "\uD83E\uDD81\uD83D\uDFE9"), m("h2", null, "Lehoidle"), m("p", {
      className: "welcome-desc"
    }, "Adivina el le\xF3n misterioso del Athletic Club en un m\xE1ximo de 8 intentos. Sin pistas previas: propone jugadores y utiliza la comparativa y el radar de deducci\xF3n para acotar el cerco.")), m("div", {
      className: "welcome-rules-grid"
    }, m("div", {
      className: "rule-item"
    }, m("div", {
      className: "rule-icon"
    }, "\uD83C\uDFAF"), m("div", null, m("strong", null, "8 Intentos para dar con \xE9l"), m("p", null, "Elige cualquier jugador de la plantilla para iniciar las comparaciones."))), m("div", {
      className: "rule-item"
    }, m("div", {
      className: "rule-icon"
    }, "\u2B06\uFE0F\u2B07\uFE0F"), m("div", null, m("strong", null, "Pistas relativas"), m("p", null, "Dorsal, edad, altura y peso te indicar\xE1n si el le\xF3n buscado es mayor o menor."))), m("div", {
      className: "rule-item"
    }, m("div", {
      className: "rule-icon"
    }, "\uD83E\uDDE0"), m("div", null, m("strong", null, "Radar de Deducci\xF3n"), m("p", null, "El juego calcula y actualiza los l\xEDmites m\xEDnimos y m\xE1ximos en tiempo real tras cada prueba."))), m("div", {
      className: "rule-item"
    }, m("div", {
      className: "rule-icon"
    }, "\uD83C\uDFC6"), m("div", null, m("strong", null, "Puntuaci\xF3n por acierto"), m("p", null, "Hasta 1.000 pts en el 1\xBA intento (se reduce progresivamente seg\xFAn los intentos gastados).")))), m("div", {
      className: "welcome-actions"
    }, m(Button, {
      className: "Button Button--primary Button--block btn-start-game",
      icon: "fas fa-play",
      onclick: () => this.startGame()
    }, "\xA1Comenzar Partida!")));
  }
  renderPlayScreen() {
    const attemptsLeft = this.maxAttempts - this.guesses.length;
    const currentPoints = LehoidleGame.POINTS_BY_ATTEMPT[this.guesses.length + 1] || 100;
    const filteredCandidates = this.dropdownOpen ? this.getFilteredCandidates(this.searchQuery) : [];
    return m("div", {
      className: "lehoidle-game play-screen"
    }, m("div", {
      className: "game-top-bar"
    }, m("div", {
      className: "attempts-stepper"
    }, m("span", {
      className: "attempts-label"
    }, "Intento ", this.guesses.length + 1, " de ", this.maxAttempts), m("div", {
      className: "attempt-dots"
    }, Array.from({
      length: this.maxAttempts
    }).map((_, idx) => {
      const isUsed = idx < this.guesses.length;
      const isCurrent = idx === this.guesses.length;
      const guess = this.guesses[idx];
      const isSuccess = guess && guess.is_target;
      return m("span", {
        key: idx,
        className: "attempt-dot ".concat(isSuccess ? 'success' : isUsed ? 'used' : '', " ").concat(isCurrent ? 'current' : '')
      });
    }))), m("div", {
      className: "top-right-badges"
    }, m("span", {
      className: "potential-points-pill"
    }, "\u2B50 ", currentPoints, " pts"), m("div", {
      className: "game-timer-badge"
    }, m("i", {
      className: "far fa-clock"
    }), m("span", null, this.formatTimer(this.timerSeconds))))), m("div", {
      className: "mystery-silhouette-banner"
    }, m("div", {
      className: "mystery-avatar-circle"
    }, m("span", {
      className: "mystery-icon"
    }, "\uD83E\uDD81"), m("span", {
      className: "mystery-question-mark"
    }, "?")), m("div", {
      className: "mystery-title"
    }, m("h3", null, "\xBFQui\xE9n es el le\xF3n oculto?"), m("p", null, this.guesses.length === 0 ? 'Prueba cualquier jugador de la plantilla para abrir las pistas.' : "Te quedan ".concat(attemptsLeft, " ").concat(attemptsLeft === 1 ? 'intento' : 'intentos', " para acertar.")))), this.radar && m("div", {
      className: "deduction-radar-card"
    }, m("div", {
      className: "radar-header"
    }, m("span", {
      className: "radar-title"
    }, m("i", {
      className: "fas fa-radar"
    }), " \uD83E\uDDE0 Radar de Deducci\xF3n Zurigorri"), m("span", {
      className: "candidates-count-badge"
    }, "\uD83D\uDC65 ", this.radar.matchingCandidates.length, " ", this.radar.matchingCandidates.length === 1 ? 'león encaja' : 'leones encajan')), m("div", {
      className: "radar-grid"
    }, m("div", {
      className: "radar-stat-box"
    }, m("span", {
      className: "stat-label"
    }, "\u26BD Demarcaci\xF3n"), m("span", {
      className: "stat-value"
    }, this.radar.confirmedPosition ? "\u2705 ".concat(this.translatePosition(this.radar.confirmedPosition)) : this.radar.discardedPositions.length > 0 ? "Desc: ".concat(this.radar.discardedPositions.map(p => this.translatePosition(p)).join(', ')) : 'Sin descartar')), m("div", {
      className: "radar-stat-box"
    }, m("span", {
      className: "stat-label"
    }, "\uD83D\uDC55 Dorsal"), m("span", {
      className: "stat-value"
    }, this.radar.minDorsal === this.radar.maxDorsal ? "\uD83C\uDFAF #".concat(this.radar.minDorsal) : "#".concat(this.radar.minDorsal, " al #").concat(this.radar.maxDorsal))), m("div", {
      className: "radar-stat-box"
    }, m("span", {
      className: "stat-label"
    }, "\uD83D\uDCCF Altura"), m("span", {
      className: "stat-value"
    }, this.radar.minHeight === this.radar.maxHeight ? "\uD83C\uDFAF ".concat(this.radar.minHeight, " cm") : "".concat(this.radar.minHeight, " - ").concat(this.radar.maxHeight, " cm"))), m("div", {
      className: "radar-stat-box"
    }, m("span", {
      className: "stat-label"
    }, "\uD83D\uDCC5 Edad"), m("span", {
      className: "stat-value"
    }, this.radar.minAge === this.radar.maxAge ? "\uD83C\uDFAF ".concat(this.radar.minAge, " a\xF1os") : "".concat(this.radar.minAge, " - ").concat(this.radar.maxAge, " a\xF1os"))), m("div", {
      className: "radar-stat-box"
    }, m("span", {
      className: "stat-label"
    }, "\u2696\uFE0F Peso"), m("span", {
      className: "stat-value"
    }, this.radar.minWeight === this.radar.maxWeight ? "\uD83C\uDFAF ".concat(this.radar.minWeight, " kg") : "".concat(this.radar.minWeight, " - ").concat(this.radar.maxWeight, " kg"))), m("div", {
      className: "radar-stat-box"
    }, m("span", {
      className: "stat-label"
    }, "\uD83D\uDCCD Origen"), m("span", {
      className: "stat-value"
    }, this.radar.confirmedTerritory ? "\u2705 ".concat(this.radar.confirmedTerritory) : this.radar.discardedTerritories.length > 0 ? "No es: ".concat(this.radar.discardedTerritories.join(', ')) : 'Sin descartar')))), m("div", {
      className: "guess-input-section"
    }, m("label", {
      className: "input-label"
    }, m("i", {
      className: "fas fa-search"
    }), " Prop\xF3n un jugador de la plantilla:"), m("div", {
      className: "autocomplete-wrapper"
    }, m("input", {
      type: "text",
      className: "FormControl autocomplete-input",
      placeholder: "Escribe el nombre del le\xF3n (ej: Sancet, Vivian, Sim\xF3n...)",
      value: this.searchQuery,
      onfocus: () => {
        this.dropdownOpen = true;
        m.redraw();
      },
      oninput: e => {
        this.searchQuery = e.target.value;
        this.selectedCandidate = null;
        this.dropdownOpen = true;
      },
      onkeydown: e => {
        if (e.key === 'Enter' && this.selectedCandidate) {
          this.submitGuess();
        }
      }
    }), this.selectedCandidate && m("button", {
      type: "button",
      className: "btn-clear-selection",
      onclick: () => {
        this.selectedCandidate = null;
        this.searchQuery = '';
        this.dropdownOpen = true;
        m.redraw();
      }
    }, m("i", {
      className: "fas fa-times"
    })), this.dropdownOpen && filteredCandidates.length > 0 && m("div", {
      className: "autocomplete-dropdown"
    }, filteredCandidates.map(c => m("div", {
      key: c.id,
      className: "candidate-option ".concat(this.selectedCandidate && this.selectedCandidate.id === c.id ? 'is-selected' : ''),
      onclick: () => this.selectCandidate(c)
    }, c.photo_url ? m("img", {
      src: c.photo_url,
      alt: c.name,
      className: "candidate-avatar"
    }) : m("span", {
      className: "candidate-avatar candidate-avatar--placeholder"
    }, "\uD83E\uDD81"), m("span", {
      className: "candidate-name"
    }, c.name), m("span", {
      className: "candidate-position"
    }, c.position_label), c.number > 0 && m("span", {
      className: "candidate-number"
    }, "#", c.number))))), m("div", {
      className: "guess-button-row"
    }, m(Button, {
      className: "Button Button--primary btn-send-guess",
      icon: "fas fa-check",
      disabled: !this.selectedCandidate,
      onclick: () => this.submitGuess()
    }, "Probar Le\xF3n (", currentPoints, " pts)"))), m("div", {
      className: "guesses-history-section"
    }, m("h4", null, "Comparativas Realizadas (", this.guesses.length, ")"), this.guesses.length === 0 ? m("div", {
      className: "empty-guesses-placeholder"
    }, m("span", {
      className: "placeholder-icon"
    }, "\uD83E\uDD81\uD83D\uDCAD"), m("p", null, "A\xFAn no has propuesto ning\xFAn jugador. \xA1Lanza tu primer candidato!")) : m("div", {
      className: "guesses-table-wrapper"
    }, m("table", {
      className: "guesses-table"
    }, m("thead", null, m("tr", null, m("th", {
      className: "th-player"
    }, "Jugador"), m("th", {
      className: "th-pos"
    }, "Posici\xF3n"), m("th", {
      className: "th-num"
    }, "Dorsal"), m("th", {
      className: "th-age"
    }, "Edad"), m("th", {
      className: "th-height"
    }, "Altura"), m("th", {
      className: "th-weight"
    }, "Peso"), m("th", {
      className: "th-terr"
    }, "Origen"))), m("tbody", null, [...this.guesses].reverse().map((g, idx) => {
      const p = g.player;
      return m("tr", {
        key: idx,
        className: "guess-row ".concat(g.is_target ? 'is-winner' : '')
      }, m("td", {
        className: "td-player"
      }, m("div", {
        className: "player-cell"
      }, p.photo_url ? m("img", {
        src: p.photo_url,
        alt: p.name,
        className: "row-avatar"
      }) : m("span", {
        className: "row-avatar--placeholder"
      }, "\uD83E\uDD81"), m("span", {
        className: "row-name"
      }, p.name))), m("td", {
        className: "tile-cell ".concat(g.position_match ? 'match-exact' : 'match-wrong')
      }, m("span", {
        className: "cell-val"
      }, p.position_label), m("span", {
        className: "cell-indicator"
      }, g.position_match ? '✅' : '❌')), m("td", {
        className: "tile-cell ".concat(g.number_direction === 'exact' ? 'match-exact' : 'match-diff')
      }, m("span", {
        className: "cell-val"
      }, "#", p.number), m("span", {
        className: "cell-indicator"
      }, g.number_direction === 'exact' ? '🎯' : g.number_direction === 'higher' ? '⬆️' : '⬇️')), m("td", {
        className: "tile-cell ".concat(g.age_direction === 'exact' ? 'match-exact' : 'match-diff')
      }, m("span", {
        className: "cell-val"
      }, p.age, "a"), m("span", {
        className: "cell-indicator"
      }, g.age_direction === 'exact' ? '🎯' : g.age_direction === 'higher' ? '⬆️' : '⬇️')), m("td", {
        className: "tile-cell ".concat(g.height_direction === 'exact' ? 'match-exact' : 'match-diff')
      }, m("span", {
        className: "cell-val"
      }, p.height, "cm"), m("span", {
        className: "cell-indicator"
      }, g.height_direction === 'exact' ? '🎯' : g.height_direction === 'higher' ? '⬆️' : '⬇️')), m("td", {
        className: "tile-cell ".concat(g.weight_direction === 'exact' ? 'match-exact' : 'match-diff')
      }, m("span", {
        className: "cell-val"
      }, p.weight, "kg"), m("span", {
        className: "cell-indicator"
      }, g.weight_direction === 'exact' ? '🎯' : g.weight_direction === 'higher' ? '⬆️' : '⬇️')), m("td", {
        className: "tile-cell ".concat(g.territory_match ? 'match-exact' : 'match-wrong')
      }, m("span", {
        className: "cell-val"
      }, p.territory), m("span", {
        className: "cell-indicator"
      }, g.territory_match ? '✅' : '❌')));
    }))))));
  }
  renderResults() {
    const r = this.results || {};
    const score = r.score || 0;
    const isSolved = Boolean(r.is_solved);
    const solvedAt = r.solved_at_attempt || 0;
    const totalAttempts = r.total_attempts || this.guesses.length;
    const durationSec = r.duration_seconds || this.timerSeconds;
    const target = r.target_player || this.targetPlayer;
    const recordUpdated = Boolean(r.record_updated);
    const isLoggedIn = Boolean(app.session.user);
    return m("div", {
      className: "lehoidle-game results-screen"
    }, m("div", {
      className: "results-summary-card"
    }, isSolved ? m("div", {
      className: "solved-banner"
    }, m("span", {
      className: "celebration-emoji"
    }, "\uD83E\uDD81\uD83C\uDFAF"), m("h3", null, "\xA1DIANA ZURIGORRI!"), m("p", null, solvedAt === 1 ? '¡Increíble! ¡Acertaste al león a la primera de forma magistral!' : "\xA1Enhorabuena! Has descubierto al le\xF3n en ".concat(solvedAt, " ").concat(solvedAt === 1 ? 'intento' : 'intentos', "."))) : m("div", {
      className: "failed-banner"
    }, m("span", {
      className: "celebration-emoji"
    }, "\uD83E\uDD81\u231B"), m("h3", null, "\xA1Agotaste los 8 intentos!"), m("p", null, "Esta vez el le\xF3n se escap\xF3 del radar.")), target && m("div", {
      className: "target-reveal-box"
    }, m("div", {
      className: "reveal-photo-wrapper"
    }, target.photo_url ? m("img", {
      src: target.photo_url,
      alt: target.name,
      className: "reveal-photo"
    }) : m("span", {
      className: "reveal-photo-placeholder"
    }, "\uD83E\uDD81")), m("div", {
      className: "reveal-info"
    }, m("span", {
      className: "reveal-role"
    }, target.position_label, " \xB7 #", target.number), m("h4", null, target.name), m("div", {
      className: "reveal-tags"
    }, m("span", {
      className: "rtag"
    }, target.height, " cm"), m("span", {
      className: "rtag"
    }, target.weight, " kg"), m("span", {
      className: "rtag"
    }, target.age, " a\xF1os"), m("span", {
      className: "rtag"
    }, target.territory)))), m("div", {
      className: "score-hero"
    }, m("div", {
      className: "score-circle"
    }, m("span", {
      className: "score-val"
    }, score), m("span", {
      className: "score-lbl"
    }, "Puntos"))), m("div", {
      className: "stats-row"
    }, m("div", {
      className: "stat-box"
    }, m("span", {
      className: "stat-num"
    }, isSolved ? "".concat(solvedAt, " / ").concat(this.maxAttempts) : 'Fallado'), m("span", {
      className: "stat-label"
    }, "Intentos")), m("div", {
      className: "stat-box"
    }, m("span", {
      className: "stat-num"
    }, this.formatTimer(durationSec)), m("span", {
      className: "stat-label"
    }, "Tiempo")), m("div", {
      className: "stat-box"
    }, m("span", {
      className: "stat-num"
    }, r.high_score || score), m("span", {
      className: "stat-label"
    }, "Tu R\xE9cord"))), recordUpdated && m("div", {
      className: "record-badge"
    }, m("i", {
      className: "fas fa-trophy"
    }), " \xA1Nuevo r\xE9cord personal en Lehoidle!"), !isLoggedIn && m("div", {
      className: "guest-warning"
    }, m("p", null, "Inicia sesi\xF3n o reg\xEDstrate para que tu r\xE9cord compute en el Ranking de Pasatiempos."), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-sign-in-alt",
      onclick: () => app.modal.show(LogInModal)
    }, "Iniciar Sesi\xF3n")), m("div", {
      className: "results-actions"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-redo",
      onclick: () => this.fetchNewRound()
    }, "Jugar Otra Partida"))), m("div", {
      className: "results-history-review"
    }, m("h4", null, "Historial de tu Partida"), m("div", {
      className: "guesses-table-wrapper"
    }, m("table", {
      className: "guesses-table"
    }, m("thead", null, m("tr", null, m("th", {
      className: "th-player"
    }, "Jugador"), m("th", {
      className: "th-pos"
    }, "Posici\xF3n"), m("th", {
      className: "th-num"
    }, "Dorsal"), m("th", {
      className: "th-age"
    }, "Edad"), m("th", {
      className: "th-height"
    }, "Altura"), m("th", {
      className: "th-weight"
    }, "Peso"), m("th", {
      className: "th-terr"
    }, "Origen"))), m("tbody", null, this.guesses.map((g, idx) => {
      const p = g.player;
      return m("tr", {
        key: idx,
        className: "guess-row ".concat(g.is_target ? 'is-winner' : '')
      }, m("td", {
        className: "td-player"
      }, m("div", {
        className: "player-cell"
      }, p.photo_url ? m("img", {
        src: p.photo_url,
        alt: p.name,
        className: "row-avatar"
      }) : m("span", {
        className: "row-avatar--placeholder"
      }, "\uD83E\uDD81"), m("span", {
        className: "row-name"
      }, p.name))), m("td", {
        className: "tile-cell ".concat(g.position_match ? 'match-exact' : 'match-wrong')
      }, m("span", {
        className: "cell-val"
      }, p.position_label), m("span", {
        className: "cell-indicator"
      }, g.position_match ? '✅' : '❌')), m("td", {
        className: "tile-cell ".concat(g.number_direction === 'exact' ? 'match-exact' : 'match-diff')
      }, m("span", {
        className: "cell-val"
      }, "#", p.number), m("span", {
        className: "cell-indicator"
      }, g.number_direction === 'exact' ? '🎯' : g.number_direction === 'higher' ? '⬆️' : '⬇️')), m("td", {
        className: "tile-cell ".concat(g.age_direction === 'exact' ? 'match-exact' : 'match-diff')
      }, m("span", {
        className: "cell-val"
      }, p.age, "a"), m("span", {
        className: "cell-indicator"
      }, g.age_direction === 'exact' ? '🎯' : g.age_direction === 'higher' ? '⬆️' : '⬇️')), m("td", {
        className: "tile-cell ".concat(g.height_direction === 'exact' ? 'match-exact' : 'match-diff')
      }, m("span", {
        className: "cell-val"
      }, p.height, "cm"), m("span", {
        className: "cell-indicator"
      }, g.height_direction === 'exact' ? '🎯' : g.height_direction === 'higher' ? '⬆️' : '⬇️')), m("td", {
        className: "tile-cell ".concat(g.weight_direction === 'exact' ? 'match-exact' : 'match-diff')
      }, m("span", {
        className: "cell-val"
      }, p.weight, "kg"), m("span", {
        className: "cell-indicator"
      }, g.weight_direction === 'exact' ? '🎯' : g.weight_direction === 'higher' ? '⬆️' : '⬇️')), m("td", {
        className: "tile-cell ".concat(g.territory_match ? 'match-exact' : 'match-wrong')
      }, m("span", {
        className: "cell-val"
      }, p.territory), m("span", {
        className: "cell-indicator"
      }, g.territory_match ? '✅' : '❌')));
    }))))), m("div", {
      className: "results-leaderboard-section"
    }, m("h4", null, "\uD83C\uDFC6 Top Foreros en Lehoidle"), m(PasatiemposLeaderboard, {
      initialFilter: "lehoidle",
      hideFilters: true,
      compact: true,
      maxItems: 10
    })));
  }
  translatePosition(pos) {
    switch (pos) {
      case 'goalkeeper':
        return 'Portero';
      case 'defender':
        return 'Defensa';
      case 'midfielder':
        return 'Centrocampista';
      case 'attacker':
        return 'Delantero';
      default:
        return pos;
    }
  }
}
_defineProperty(LehoidleGame, "POINTS_BY_ATTEMPT", {
  1: 1000,
  2: 850,
  3: 700,
  4: 550,
  5: 400,
  6: 300,
  7: 200,
  8: 100
});
flarum.reg.add('nagusi-match-ratings', 'forum/pasatiempos/LehoidleGame', LehoidleGame);